var ContactSalesConfigurationService = (function () {
    function ContactSalesConfigurationService($http) {
        this.$http = $http;
    }
    ContactSalesConfigurationService.prototype.get = function () {
        var url = 'compatibilityguide/ng-settings/feature/forms/contactsales';
        return this.$http
            .get(url)
            .then(function (response) {
            return response.data;
        });
    };
    ContactSalesConfigurationService.$inject = ['$http'];
    return ContactSalesConfigurationService;
}());
export { ContactSalesConfigurationService };
